import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {DxDataGridComponent} from "devextreme-angular";
import { Movimento } from 'src/app/models/Movimento';
import {DxService} from "../../../services/dx.service";
import {environment} from "../../../../environments/environment";
import {ActivatedRoute, Route, Router} from "@angular/router";
import {TIPO_ORDINE} from "../../../models/Ordine";

@Component({
   selector: 'app-tab-storico-assortimenti',
   templateUrl: './tab-storico-assortimenti.component.html',
   styleUrls: ['./tab-storico-assortimenti.component.scss']
})
export class TabStoricoAssortimentiComponent implements OnInit, AfterViewInit {
   @ViewChild('gridStoricoAss') gridStoricoAss!:DxDataGridComponent;
   @Input() prodottoId:number | null = null
   @Input() vendorSlug;
   @Input() isVariante = false;
   @Input() pVariantId;
   @Input() pVariantInstanceId;
   @Input() showFilter = true;
   @Input() showColumnStampa = false;
   @Input() tipoTabella: string = '0';
   @Input() pVenditaId;
   ordineConvalidaId;
   ordineConvalidaSlaveId;
   ordineId;
   ordineSlaveId;
   Movimento = Movimento

   movimento:Movimento = new Movimento({})

   maxEtichette = 0
   TIPO_ORDINE = TIPO_ORDINE;

   public popupProfiloStampa: boolean = false;

   constructor(private dxSrv: DxService,
               private route: ActivatedRoute,
               private router: Router
               ) { }

   ngOnInit(): void {
   }

   ngAfterViewInit(): void {
      if (this.prodottoId || this.pVariantInstanceId) this.initGrid()
   }

   public refreshGridLayout() {
      this.dxSrv.fixGridLayout(this.gridStoricoAss);
   }

   initGrid(){
      let url = `/api/esercizi/${this.vendorSlug}/prodotti/${this.prodottoId}/storico_movimenti?tipo=${this.tipoTabella}`
      console.log(url)
      if (this.isVariante) url = `/api/esercizi/${this.vendorSlug}/prodotti/${this.prodottoId}/p_variant/${this.pVariantId}/storico_movimenti?tipo=${this.tipoTabella}`
      if (this.pVariantInstanceId) url = `/api/esercizi/${this.vendorSlug}/pvenditaprodvarinst/${this.pVariantInstanceId}/storico_movimenti?tipo=${this.tipoTabella}`
      this.dxSrv.initGrid(this.gridStoricoAss, {}, url).then(() => {
         setTimeout(() => {
            this.refreshGridLayout();
         }, 50);
      })
   }

   clickOpenPrint(data) {
      console.log(data)
      this.movimento = new Movimento(data)
      this.maxEtichette = data.qta
      this.ordineConvalidaSlaveId= data.id
      this.ordineConvalidaId= data.convalida_slave
      this.ordineId = data.ordine_id
      this.ordineSlaveId = data.ordine_slave
      this.popupProfiloStampa = true
   }

   onClosePrintModal($event: any) {
      this.popupProfiloStampa = false
   }

   stampaConvalide(data: any) {
      console.log(data)

      let profStampId = data.profilo
      let skipEtichette = data.skipEtichette
      let daStampare = data.daStampare
      // let selectedRows = this.grid?.instance.getSelectedRowKeys()
      // let ordineConvalidaId = this.convalideSlave[0].ordine_convalida

      if (this.movimento.data.tipo == 'tras')
         window.open(environment.urlServer + `/api/esercizi/${this.vendorSlug}/pvendita/${this.pVenditaId}/etichette/stampa?profilo=${profStampId}&skipEtichette=${skipEtichette}&daStampare=${daStampare}&ordine_id=${this.movimento.data.ordine_id}&ordine_slave_id=${this.movimento.data.ordine_slave}&pdf=1`)

      else window.open(environment.urlServer + `/api/esercizi/${this.vendorSlug}/pvendita/${this.pVenditaId}/etichette/stampa?ordslaveconvid=${this.ordineConvalidaId}&profilo=${profStampId}&skipEtichette=${skipEtichette}&daStampare=${daStampare}&ordineconvalidaid=${this.ordineConvalidaSlaveId}&pdf=1`)
   }

   clickGoToDDT(data) {
      console.log(data)
      this.router.navigate([`../ordini-fornitore/${data.ordine_id}`], {relativeTo:this.route})
   }

   tet(data) {
      console.log(data)
   }

}
